import React, { useState } from "react";
import { get_order_detail } from "../../../controller/razor_payment";
import { server_address } from '../../../../config';
export const PaymentUI = () => {

    const [loader, setLoader] = useState(false);
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");

    const validateAmount = async () => {
        if (loader) {
            return
        }
        setLoader(true)
        if (amount === "" || amount === null) {
            setError("Please enter an amount.");
            return false;
        }

        if (Number(amount) <= 0) {
            setError("Amount must be greater than 0.");
            return false;
        }

        setError("");
        const order_detail = await get_order_detail(amount * 100);
        if (order_detail.length !== 0) {
            const loadRazorpay = () => {
                return new Promise((resolve) => {
                    if (document.getElementById("razorpay-script")) {
                        resolve(true);
                        return;
                    }
                    const script = document.createElement("script");
                    script.id = "razorpay-script";
                    script.src = "https://checkout.razorpay.com/v1/checkout.js";
                    script.onload = () => resolve(true);
                    script.onerror = () => resolve(false);
                    document.body.appendChild(script);
                });
            };
            var options = {
                "key": "rzp_test_RmS9j2gPUxb05Y", // Enter the Key ID generated from the Dashboard
                "amount": order_detail[0], // Amount is in currency subunits. 
                "currency": "INR",
                "name": "GST WEB",
                "description": "Test Transaction",
                "image": "https://example.com/your_logo",
                "order_id": order_detail[1], //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                "callback_url": `${server_address}razorpay_payment_data/`,
                "prefill": {
                    "name": "<name>",
                    "email": "<email>",
                    "contact": "<phone>"
                },
                "notes": {
                    "address": "Razorpay Corporate Office"
                },
                "method": {
                    "upi": true,          // FORCE SHOW UPI
                    "card": true,
                    "netbanking": true,
                    "wallet": true,
                    "paylater": true
                },
                "theme": {
                    "color": "#3399cc"
                }
            };
            await loadRazorpay();
            var rzp1 = new window.Razorpay(options);
            rzp1.open();
            setLoader(false);
        }
        setLoader(false);
        return true;
    };

    return (
        <div style={styles.container}>

            <input
                type="number"
                placeholder="Enter Amount (₹)"
                value={amount}
                min="1"
                onChange={(e) => setAmount(e.target.value)}
                style={styles.input}
            />

            {error && <p style={styles.error}>{error}</p>}

            <button onClick={validateAmount} id='rzp-button1' style={styles.button}>
                {loader ? <div className="loader"></div> : 'Pay with Razorpay'}
            </button>
        </div>
    );
};

// Inline styles
const styles = {
    container: {
        width: "300px",
        padding: "20px",
        margin: "50px auto",
        border: "1px solid #ddd",
        borderRadius: "8px",
        textAlign: "center",
        background: "#fafafa",
    },
    title: {
        marginBottom: "15px",
    },
    input: {
        width: "100%",
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        marginBottom: "10px",
        outline: "none",
    },
    button: {
        width: "100%",
        padding: "10px",
        background: "#3399cc",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    error: {
        color: "red",
        marginBottom: "10px",
        fontSize: "14px",
    },
};

export default PaymentUI;
